/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Accounting / records mode used in the filing.
 * @nullable
 */
export type GetSloveniaTaxProfile200YearlyReportingAccountingType = typeof GetSloveniaTaxProfile200YearlyReportingAccountingType[keyof typeof GetSloveniaTaxProfile200YearlyReportingAccountingType] | null;


export const GetSloveniaTaxProfile200YearlyReportingAccountingType = {
  records: 'records',
  single_entry: 'single_entry',
  double_entry: 'double_entry',
} as const;
